<template>
  <div class="projectManagement">
    <div class="title_box">
      <el-col :span="13">
        <h4>病例库列表</h4>
      </el-col>
      <!-- 左边的输入框 -->
      <div class="inputBox">
        <el-input
          :clearable="true"
          placeholder="请输入病例名称"
          v-model="input2"
          clearable
          @change="change"
        >
        </el-input>
        <el-button
          size="medium"
          style="background: #484c7f; color: #fff"
          @click="searchExpert"
        >搜索</el-button>
      </div>
      <!-- 搜索区域 -->
      <div class="searchBox">
        <!-- 右侧的按钮 -->
        <div class="buttonBox">
          <el-button
            size="medium"
            style="background: #258ce8; color: #fff"
            @click="experteditor"
          >发布病例</el-button>
        </div>
      </div>
    </div>
    <!-- 卡片 -->
    <el-card class="box-card">
      <div
        class="box"
        ref="navigat"
      >
        <ul
          class="classfiy"
          ref="navigatUl"
        >
          <span>科室:</span>
          <li
            v-for="(item,index) in navigatList"
            :key="index"
            @click="navigatClick(index,item)"
            :class="item.id===navigatIndex?'active':'' "
          >{{item.name}}</li>
          <span
            v-if="navigatIcon"
            @click="pulldownClick"
            class="xila"
          ><i class="el-icon-arrow-down"></i></span>
          <span
            v-if="highPull"
            class="shang"
            @click="highPullClick"
          ><i class="el-icon-arrow-up"></i></span>
        </ul>
      </div>
    </el-card>

    <!-- 有数据 -->
    <div v-show="expertObject.list!=0">
      <!-- 这里是一个表单 -->
      <div class="el_table">
        <el-table
          :data="expertObject.list"
          style="width: 100%;cursor: pointer;"
          @row-click="locations"
        >
          <el-table-column
            fixed
            prop="image"
            label="封面图"
            min-width="20%"
          >
            <template slot-scope="scope">
              <div class="pictor">
                <!-- <el-image v-if="scope.row.image=='' "></el-image> -->
                <el-image v-if="scope.row.image=='' ">
                  <div
                    class="r_sbox-img-slot"
                    slot="error"
                  >暂无</div>
                </el-image>
                <img
                  v-else
                  :src="scope.row.image"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="病例名称"
            min-width="50%"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="发布时间"
            min-width="20%"
          >
          </el-table-column>
          <!-- <el-table-column
            fixed="right"
            label="修改病例"
            min-width="10%"
          >
            <template slot-scope="scope">
              <i
                v-if="userinfo.userid==scope.row.u_id"
                class="iconfont icon-bianji"
                @click.stop="toeditor(scope.row.id)"
              ></i>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <!-- 表单结束 -->
      <div
        class="page"
        v-show="expertObject.list!=0"
      >
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentchange"
          @prev-click="prevClick"
          @next-click="nextClick"
          :page-count="expertObject.pages"
          :current-page.sync="currentPage"
          hide-on-single-page
        >
        </el-pagination>
      </div>
      <div
        v-show="expertObject.list==0"
        class="available"
      >当前页面无数据</div>
      <!-- 分页 -->
    </div>
    <!-- 无数据 -->
    <div
      class="available"
      v-show="expertObject.list==0"
    >暂无数据</div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      userinfo: {},
      input2: '',
      // 是否弹出对话框 
      dialogVisible: false,
      navigatList: [],
      navigatIndex: 0,
      navigatIcon: false,
      highPull: false,
      //病例
      total: 0,//总条目数
      pagesize: 8,//每页显示条目个数
      currentPage: 1,//当前页数  
      expertObject: {},
      selectIcon: true
    }
  },
  mounted () {
    this.getCateLlist()
  },
  //keep-alive 激活触发
  activated () {
    this.userinfo = JSON.parse(localStorage.getItem("userinfo"))
    this.getExpertList()
  },
  //keep-alive 停用触发
  deactivated () {
    this.navigatIndex = 0
    this.input2 = ''
    this.getExpertList()
  },
  watch: {
    //监听上拉
    highPull: {
      handler (newVal, oldVal) {
        this.$nextTick(function () {
          if (this.$refs.navigat.clientHeight > 100) this.highPull = true
        })
      },
      immediate: true,
    },
  },
  methods: {
    // 发布病例
    experteditor () {
      this.$router.push({
        path: '/Caseeditor',
        query: {
          id: ''
        }
      })
    },
    handleClick (row) {
      console.log(row);
    },
    // 点击每一行跳转
    locations (row) {
      this.$router.push({
        path: '/Casedetail',
        query: {
          id: row.id
        }
      })
    },
    //编辑
    toeditor (id) {
      this.$router.push({
        path: '/Caseeditor',
        query: {
          id
        }
      })
    },
    //点击导航
    navigatClick (i, item) {
      this.navigatIndex = item.id
      setTimeout(() => {
        this.currentPage = 1
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //上拉
    highPullClick () {
      this.$nextTick(() => {
        if (this.$refs.navigat.clientHeight > 100) this.highPull = true
        this.$refs.navigat.style.height = `95px`
        this.navigatIcon = true
        this.highPull = false
      });
    },
    //点击导航下拉 
    pulldownClick () {
      this.$nextTick(() => {
        this.$refs.navigat.style.height = `${this.$refs.navigatUl.clientHeight}px`
        this.navigatIcon = false
        this.highPull = true
      })
    },
    //决定导航是否下拉
    decidePulldown () {
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.navigat.offsetHeight < 110) {
            this.highPull = false
          }
          if (this.$refs.navigatUl.offsetHeight > 110) {
            this.navigatIcon = !this.highPull;
          }
          if (this.$refs.navigat.offsetHeight == 0) {
            this.highPull = true
          }
        });
      });
    },
    //搜索
    searchExpert () {
      this.currentPage = 1
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    change (value) {
      this.input2 = value
      this.currentPage = 1
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //获取科室
    async getCateLlist () {
      const { data: data } = await this.$http.post("cate/list", {
        type: '1'
      })
      let arr = []
      arr.push({
        id: 0,
        name: '全部',
      }, ...data.data)
      this.navigatList = arr
      setTimeout(() => {
        this.decidePulldown()
      }, 200);
    },
    //获取专家列表
    async getExpertList () {
      let Replacements = this.navigatIndex
      if (this.navigatIndex == 0) Replacements = ''
      const { data: data } = await this.$http.post("bl/list", {
        name: this.input2, //搜索
        cate_id: Replacements, //科室 this.navigatIndex
        page: this.currentPage,//第几页
        limit: this.pagesize,
      })
      this.$Spin.hide();
      this.expertObject = data.data
    },
    //点击每一页 
    currentchange (e) {
      this.currentPage = e
      document.querySelector('.el-main').scrollTop = 0
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      document.querySelector('.el-main').scrollTop = 0
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //下一页
    nextClick (e) {
      this.currentPage = e
      document.querySelector('.el-main').scrollTop = 0
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
  }
}
</script>

<style lang='less' scoped>
.projectManagement {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  .title_box {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
    .inputBox {
      flex: 1;
      display: flex;
      margin-right: 56px;
      .el-input {
        flex: 1;
        margin-right: 16px;
      }
      .setDateTitle {
        margin-right: 14px;
        color: #8588ae;
        font-size: 18px;
      }
    }
  }
  .el-card {
    .box {
      position: relative;
      height: 95px;
      overflow: hidden;
      transition: all 0.3s;
      .classfiy {
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        span {
          color: #212529;
          font-size: 16px;
          line-height: 35px;
          // padding-right: 20px;
          margin: 7px 20px;
        }
        li {
          font-size: 16px;
          color: #212529;
          margin-right: 30px;
          padding: 0 11px;
          margin: 7px;
          line-height: 35px;
          cursor: pointer;
          transition: all 0.3s;
        }
        .active {
          border-radius: 4px;
          background: #484c7f;
          color: #fff;
        }

        .xila {
          position: absolute;
          bottom: 0px;
          right: -22px;
          font-size: 22px;
          cursor: pointer;
          z-index: 999;
          background-color: #fff;
          &:hover {
            color: #484c7f;
          }
        }
        .shang {
          position: absolute;
          bottom: 0px;
          right: -22px;
          cursor: pointer;
          font-size: 22px !important;
          &:hover {
            color: #484c7f;
          }
        }
      }
    }
  }
  .el_table {
    margin-top: 40px;
    //最低高度
    min-height: 480px;
    .pictor {
      width: 160px;
      height: 80px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      /deep/ .el-image {
        width: 100% !important;
        height: 100% !important;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f5f7fa;
        .r_sbox-img-slot {
          font-size: 14px;
          color: #c0c4cc;
          vertical-align: middle;
        }
      }
    }
    .iconfont {
      font-size: 17px;
      color: #b966d5;
    }
  }
  .page {
    margin-top: 30px;
    text-align: right;
  }
  /deep/ .el-card__body {
    padding: 10px;
  }
}

.available {
  color: #8588ae;
  margin: 0 auto;
  padding-top: 320px;
}
</style>
